import React from 'react';
import { MapFx, types } from 'utils';

interface Props {
    options: types.ComparisonOption;
}

const ComparisonDisplay = ({ options }: Props) => {

    // eslint-disable-next-line
    const [mapData, setMapData] = React.useState<any[]>([]);
    const [mapInstance, setMapInstance] = React.useState<typeof MapFx.prototype[]>();

    React.useEffect(() => {
        if (options.year.length > 0 && options.year[0] !== options.year[1]) {
            const map1 = new MapFx({
                mapId: `map_${options.year[0]}`,
                vdcId: `voteDistributionChart_${options.year[0]}`,
                tucId: `turnoutChart_${options.year[0]}`,
                vvcId: `validVotesChart_${options.year[0]}`,
                chartIndex: 0,
                loadData: (data) => setMapData((prevData) => [...prevData, data]),
            });

            const map2 = new MapFx({
                mapId: `map_${options.year[1]}`,
                vdcId: `voteDistributionChart_${options.year[1]}`,
                tucId: `turnoutChart_${options.year[1]}`,
                vvcId: `validVotesChart_${options.year[1]}`,
                chartIndex: 1,
                loadData: (data) => setMapData((prevData) => [...prevData, data]),
            });

            setMapInstance([map1, map2]);

            return () => {
                map1.removeMap();
                map2.removeMap();
            };
        }
    }, [options]);

    React.useEffect(() => {
        if (mapInstance) {
            mapInstance[0].loadGeoJsonForYear(options.year[0], options.type);
            mapInstance[1].loadGeoJsonForYear(options.year[1], options.type);
        }// eslint-disable-next-line
    }, [mapInstance]);


    return (
        <div className="px-8">
            {/* Horizontal Layout for Maps */}
            <div className="grid grid-cols-2 gap-6 mt-6">
                {options.year.map((year, index) => (
                    <div key={`${year}_${index}`} className="border rounded-lg shadow-lg bg-white">
                        <div className="text-center p-3 text-lg bg-red-700 text-white rounded-t-lg font-bold">
                            {options.type} Results for {year}
                        </div>
                        <div id={`map_${year}`} className="h-[400px]" />
                    </div>
                ))}
            </div>

            {/* Analysis Section Below Maps */}
            <div className="grid grid-cols-2 gap-6 mt-6">
                {options.year.map((year, index) => (
                    <div key={`analysis_${year}_${index}`} className="bg-gray-100 p-4 rounded-lg">
                        <div className="text-center text-lg font-semibold mb-4">
                            Analysis for {year}
                        </div>
                        <div className="space-y-4">
                            <div className="h-[200px] bg-white rounded-lg shadow">
                                <canvas id={`voteDistributionChart_${year}`} />
                            </div>
                            <div className="h-[200px] bg-white rounded-lg shadow">
                                <canvas id={`turnoutChart_${year}`} />
                            </div>
                            <div className="h-[200px] bg-white rounded-lg shadow">
                                <canvas id={`validVotesChart_${year}`} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ComparisonDisplay;